<div class="avatar-component visitor-avatar">
  <ng-container *ngIf="isTextChat; else noDisplayImage">
    <ng-container *ngIf="(visitor$ | async) as visitor; else loading">
      <ng-container *ngIf="visitor.displayImageUrl; else noUrl">
        <img class="text-chat-icon" [attr.src]="visitor.displayImageUrl"/>
      </ng-container>

      <ng-template #noUrl>
        <svg-avatar [id]="avatarThemeId"></svg-avatar>
      </ng-template>
    </ng-container>

    <ng-template #loading>
      <svg-icon icon="refresh" class="icon-loading svg-icon-spin"></svg-icon>
    </ng-template>
  </ng-container>

  <ng-template #noDisplayImage>
    <svg-avatar *ngIf="isChat" [id]="avatarThemeId"></svg-avatar>

    <svg-avatar *ngIf="isPinvite" [id]="'invite'"></svg-avatar>

    <ng-container *ngIf="isDiscussion">
      <div class="profile-initial" *ngIf="getInitials()">{{ getInitials() }}</div>
      <svg-icon icon="person-filled" *ngIf="!getInitials()"></svg-icon>
    </ng-container>

    <svg-icon *ngIf="isComposeEmail || (!isChat && !isTextChat && !isPinvite && !isDiscussion)" icon="{{ getIconClass() }}"></svg-icon>
  </ng-template>
</div>
